import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IUserTaskStateDto } from '@nimbus-library/features/user-state/models/user-task-state.model';
import { ApiRoutes } from '../../models/routes/api-routes';

@Injectable({ providedIn: 'root' })
export class UserStateApiClient {
  public constructor(private readonly baseHttpService: BaseHttpService) {}

  public getUserTaskState(userId: string): Observable<IUserTaskStateDto> {
    return this.baseHttpService.get(ApiRoutes.userState.getUserTaskState(userId));
  }
}
